<ng-template
    #content
    let-modal
>
    <div class="modal-header">
        <h4 class="modal-title">{{modalTitle}}</h4>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="close()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        {{modalBody}}
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-outline-dark"
            (click)="close();confirm.emit();"
        >
            Yes
        </button>
        <button
            type="button"
            class="btn btn-outline-dark"
            (click)="close()"
        >
            No
        </button>
    </div>
</ng-template>
